/* ==================================================================
   LC 25/09 — Zoom au clic dans l'agrandissement des photos produit.
   Mise en forme : assets/lc-zoom.css.
   Contexte et mesures : snippets/product-media-modal.liquid.
   ================================================================== */

(function () {
  // Bornes du facteur d'agrandissement. Sous 2 le clic ne se verrait pas ;
  // au-delà de 3 on dépasse ce que le regard cherche sur une pièce.
  var MIN = 2;
  var MAX = 3;

  // On agrandit jusqu'à la limite du fichier : sa définition réelle rapportée
  // aux pixels physiques qu'occupe l'image à l'écran. Avec des originaux de
  // 1280 px sur un écran Retina la borne basse s'applique et le zoom est un peu
  // mou — c'est le fichier qui manque, pas le réglage.
  function factor(img) {
    var shown = img.getBoundingClientRect().width;
    var dpr = window.devicePixelRatio || 1;
    if (!shown || !img.naturalWidth) return MIN;
    return Math.min(MAX, Math.max(MIN, img.naturalWidth / (shown * dpr)));
  }

  // Le point sous le pointeur devient le centre de l'agrandissement : c'est ce
  // qui fait le cadrage au clic, puis le déplacement à la souris.
  function origin(box, x, y) {
    var r = box.getBoundingClientRect();
    var px = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
    var py = Math.min(100, Math.max(0, ((y - r.top) / r.height) * 100));
    return px.toFixed(2) + '% ' + py.toFixed(2) + '%';
  }

  function zoomIn(box, x, y) {
    var img = box.querySelector('img');
    if (!img) return;
    img.style.transformOrigin = origin(box, x, y);
    img.style.transform = 'scale(' + factor(img).toFixed(3) + ')';
    box.classList.add('is-zoomed');
  }

  function zoomOut(box) {
    var img = box.querySelector('img');
    if (img) img.style.transform = '';
    box.classList.remove('is-zoomed');
  }

  function closest(node, selector) {
    return node && node.closest ? node.closest(selector) : null;
  }

  // Dawn ferme la visionneuse au moindre pointerup de souris qui n'est pas sur
  // une vidéo ou un modèle 3D (assets/global.js, ModalDialog, branche
  // media-modal). Sans cette garde, le clic destiné au zoom fermerait la
  // fenêtre. On arrête l'événement en phase de capture, avant qu'il n'atteigne
  // product-modal ; le clic ailleurs continue de fermer, ce qui reste le bon
  // comportement.
  document.addEventListener(
    'pointerup',
    function (event) {
      if (closest(event.target, '.lc-zoom')) event.stopPropagation();
    },
    true
  );

  document.addEventListener('click', function (event) {
    var box = closest(event.target, '.lc-zoom');
    if (!box) return;
    if (box.classList.contains('is-zoomed')) zoomOut(box);
    else zoomIn(box, event.clientX, event.clientY);
  });

  document.addEventListener('mousemove', function (event) {
    var box = closest(event.target, '.lc-zoom.is-zoomed');
    if (!box) return;
    box.querySelector('img').style.transformOrigin = origin(box, event.clientX, event.clientY);
  });

  document.addEventListener(
    'touchmove',
    function (event) {
      var touch = event.touches[0];
      if (!touch) return;
      var box = closest(document.elementFromPoint(touch.clientX, touch.clientY), '.lc-zoom.is-zoomed');
      if (!box) return;
      event.preventDefault();
      box.querySelector('img').style.transformOrigin = origin(box, touch.clientX, touch.clientY);
    },
    { passive: false }
  );

  // Remise à zéro à la fermeture, pour ne pas rouvrir la visionneuse agrandie.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-modal').forEach(function (modal) {
      new MutationObserver(function () {
        if (!modal.hasAttribute('open')) {
          modal.querySelectorAll('.lc-zoom.is-zoomed').forEach(zoomOut);
        }
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  });
})();
